import React, { useState, useEffect } from 'react';
import {
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaEdit,
  FaSave,
  FaTimes
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../services/api';
import './Profile.css';

const Profile = () => {
  const [corporator, setCorporator] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    address: '',
    ward: ''
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await api.get('/api/me');
      const data = res.data.data;

      setCorporator(data);

      setFormData({
        name: data.name || '',
        mobile: data.mobile || '',
        address: data.address || '',
        ward: data.ward || ''
      });
    } catch (err) {
      toast.error('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!corporator) return;

  // Compare with original profile
  const noChanges =
    formData.name.trim() === (corporator.name || "").trim() &&
    formData.mobile.trim() === (corporator.mobile || "").trim() &&
    formData.address.trim() === (corporator.address || "").trim() &&
    formData.ward.trim() === (corporator.ward || "").trim();

  if (noChanges) {
    toast.info("No changes to update.");
    setIsEditing(false);
    return;
  }

  setSaving(true);

  try {
    const res = await api.put("/api/me", formData);

    const updatedUser = res.data.data;

    setCorporator(updatedUser);

    setFormData({
      name: updatedUser.name || "",
      mobile: updatedUser.mobile || "",
      address: updatedUser.address || "",
      ward: updatedUser.ward || ""
    });

    setIsEditing(false);

    toast.success("Profile updated successfully");
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Profile update failed"
    );
  } finally {
    setSaving(false);
  }
};
  if (loading) {
    return (
      <div className="loading-container">
        Loading Profile...
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-card">

        <div className="profile-header">
          <div className="profile-avatar">
            <FaUser />
          </div>

          <h1>{corporator?.name}</h1>
          <p className="profile-role">Ward Corporator</p>
        </div>

        <form
          className="profile-form"
          onSubmit={handleSubmit}
        >

          <div className="form-section">
            <h3>Personal Information</h3>

            <div className="form-group">
              <label>
                <FaUser /> Full Name
              </label>

              <input
                type="text"
                name="name"
                value={formData.name}
                disabled={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>
                <FaPhone /> Mobile
              </label>

              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                disabled={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>
                <FaMapMarkerAlt /> Address
              </label>

              <input
                type="text"
                name="address"
                value={formData.address}
                disabled={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>
                <FaMapMarkerAlt /> Ward
              </label>

              <input
                type="text"
                name="ward"
                value={formData.ward}
                disabled={!isEditing}
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="form-actions">

            {!isEditing ? (
             <button
  type="button"
  className="edit-btn"
  onClick={(e) => {
    e.preventDefault();
    setIsEditing(true);
  }}
>
  <FaEdit /> Edit Profile
</button>
            ) : (
              <>
                <button
                  type="submit"
                  className="save-btn"
                  disabled={saving}
                >
                  <FaSave />
                  {saving ? ' Saving...' : ' Save Changes'}
                </button>

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => {
                    setIsEditing(false);
                    fetchProfile();
                  }}
                >
                  <FaTimes /> Cancel
                </button>
              </>
            )}

          </div>

        </form>

        <div className="profile-stats">
          <h3>Account Information</h3>

          <div className="stats-grid">

            <div className="stat-item">
              <label>Role</label>
              <p>{corporator?.role}</p>
            </div>

            <div className="stat-item">
              <label>Status</label>
              <p className="verified">
                {corporator?.isVerified ? "Verified" : "Pending"}
              </p>
            </div>

            <div className="stat-item">
              <label>Last Login</label>
              <p>
                {corporator?.lastLogin
                  ? new Date(corporator.lastLogin).toLocaleString("en-IN")
                  : "-"}
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Profile;